<template>
  <el-container class="layout-container">
    <el-aside :width="sidebarCollapsed ? '64px' : '200px'" class="sidebar-container">
      <Sidebar />
    </el-aside>
    <el-container>
      <el-header class="header-container">
        <Navbar />
      </el-header>
      <TagsView />
      <el-main class="main-container">
        <keep-alive :include="cachedViews">
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from './Sidebar.vue'
import Navbar from './Navbar.vue'
import TagsView from './TagsView.vue'

export default {
  name: 'Layout',
  components: { Sidebar, Navbar, TagsView },
  computed: {
    ...mapGetters(['sidebarCollapsed', 'cachedViews'])
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}
.sidebar-container {
  background-color: #304156;
  transition: width 0.3s;
  overflow: hidden;
}
.header-container {
  padding: 0;
  height: 50px !important;
  line-height: 50px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}
.main-container {
  background-color: #f0f2f5;
  padding: 20px;
  overflow-y: auto;
}
</style>
